import {Box, Paper, Typography} from "@mui/material";

import {currencyFormatter} from "../../../lib/presentation";

export default function OrdersMetrics ({attributedShare, filteredCount, readyForWarehouse, totalValue}: {
    attributedShare: string;
    filteredCount: number;
    readyForWarehouse: number;
    totalValue: number;
}) {
    return <Box className="metric-grid"><Paper className="metric-card" elevation={0}><Typography variant="overline">Във
        филтъра</Typography><Typography variant="h4">{filteredCount}</Typography><Typography color="text.secondary">Поръчки,
        които отговарят на текущото търсене и избраните филтри</Typography></Paper><Paper className="metric-card"
                                                                                          elevation={0}><Typography
        variant="overline">Обща стойност</Typography><Typography
        variant="h4">{currencyFormatter.format (totalValue)}</Typography><Typography color="text.secondary">Сумирана
        стойност на поръчките в текущия изглед</Typography></Paper><Paper className="metric-card"
                                                                          elevation={0}><Typography variant="overline">Към
        склад</Typography><Typography variant="h4">{readyForWarehouse}</Typography><Typography color="text.secondary">Поръчки,
        които вече са в активна подготовка</Typography></Paper><Paper className="metric-card" elevation={0}><Typography
        variant="overline">Атрибуция</Typography><Typography variant="h4">{attributedShare}</Typography><Typography
        color="text.secondary">Дял на поръчките с видима връзка към кампания или договорен
        канал</Typography></Paper></Box>;
}
